(function () {
  'use strict';

  function initAllGalleries(root) {
    (root || document).querySelectorAll('.masonry-gallery').forEach(function (g) {
      if (g.dataset.galleryInit === '1') return;
      g.dataset.galleryInit = '1';
      initGallery(g);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAllGalleries(); });
  } else {
    initAllGalleries();
  }

  // Theme editor: re-init when the merchant navigates / reorders / edits.
  document.addEventListener('shopify:section:load', function (e) {
    initAllGalleries(e.target);
  });
  document.addEventListener('shopify:section:reorder', function (e) {
    initAllGalleries(e.target);
  });
  document.addEventListener('shopify:block:select', function (e) {
    // When the merchant selects an image block, scroll it into view in the preview
    var item = e.target && e.target.closest && e.target.closest('.masonry-gallery__item');
    if (item) {
      item.classList.remove('masonry-gallery__item--hidden');
      item.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
  });

  function initGallery(gallery) {
    var grid = gallery.querySelector('.masonry-gallery__grid');
    var filterBtns = gallery.querySelectorAll('.masonry-gallery__filter-btn');
    var items = gallery.querySelectorAll('.masonry-gallery__item');

    // In the theme editor (Shopify.designMode === true), force EVERY item
    // visible and eager-load all images so the merchant can actually see and
    // manage blocks. The default-category hiding + lazy-loading we use on the
    // live site makes block management impossible in the small editor iframe.
    var inEditor = !!(window.Shopify && window.Shopify.designMode);
    if (inEditor) {
      items.forEach(function (item) {
        item.classList.remove('masonry-gallery__item--hidden');
        item.querySelectorAll('img').forEach(function (img) {
          if (!img.complete) {
            img.loading = 'eager';
            img.fetchPriority = 'high';
          }
        });
      });
    }
    var lightbox = gallery.querySelector('.masonry-lightbox');
    var lightboxImg = lightbox.querySelector('.masonry-lightbox__img');
    var lightboxClose = lightbox.querySelector('.masonry-lightbox__close');
    var lightboxPrev = lightbox.querySelector('.masonry-lightbox__nav--prev');
    var lightboxNext = lightbox.querySelector('.masonry-lightbox__nav--next');
    var lightboxCounter = lightbox.querySelector('.masonry-lightbox__counter');

    // Initial active filter comes from whichever button is server-rendered with
    // .is-active. Falls back to the first button if none is active.
    var initialActiveBtn = gallery.querySelector('.masonry-gallery__filter-btn.is-active')
      || gallery.querySelector('.masonry-gallery__filter-btn');
    var activeFilter = initialActiveBtn ? initialActiveBtn.getAttribute('data-filter') : '';
    var currentIndex = 0;
    var touchStartX = 0;
    var touchEndX = 0;

    var isAnimating = false;
    var FADE_OUT_MS = 300;
    var FADE_IN_MS = 350;
    var masonryInstance = null;

    // ---- Initialize Desandro Masonry once images have loaded ----
    function relayout() {
      if (masonryInstance && typeof masonryInstance.layout === 'function') {
        masonryInstance.layout();
      }
    }

    // refilter() re-evaluates the itemSelector (so newly-shown/hidden items
    // are reconsidered) AND re-positions everything. Call after toggling the
    // --hidden class on any items.
    function refilter() {
      if (!masonryInstance) return;
      if (typeof masonryInstance.reloadItems === 'function') {
        masonryInstance.reloadItems();
      }
      masonryInstance.layout();
    }

    function initMasonry() {
      if (typeof Masonry === 'undefined' || !grid) return;
      masonryInstance = new Masonry(grid, {
        itemSelector: '.masonry-gallery__item:not(.masonry-gallery__item--hidden)',
        percentPosition: true,
        // `|| 16` would defeat a deliberate gap of 0, since 0 is falsy — a
        // gap of zero is a valid choice, so only fall back when the value
        // is genuinely absent or unparseable.
        gutter: (() => {
          const gap = parseFloat(getComputedStyle(grid).getPropertyValue('--masonry-gap'));
          return Number.isFinite(gap) ? gap : 16;
        })(),
        transitionDuration: '0.3s',
      });
    }

    // Init Masonry immediately so the layout appears as soon as the DOM is ready.
    // Items have width/height attrs (set by Shopify's image_tag), so the browser
    // reserves the correct aspect ratio before each image actually decodes.
    initMasonry();

    // Then re-layout as each image actually loads, so any size corrections
    // (and progressive image arrivals) reflow smoothly.
    if (typeof imagesLoaded === 'function') {
      var imgLoad = imagesLoaded(grid);
      imgLoad.on('progress', relayout);
      imgLoad.on('always', relayout);
    } else {
      window.addEventListener('load', relayout);
    }

    // ---- Per-image fade-in on load ----
    items.forEach(function (item) {
      var img = item.querySelector('img');
      if (!img) return;
      if (img.complete && img.naturalWidth > 0) {
        // Already loaded (browser cache, or render finished before script ran)
        img.classList.add('is-loaded');
      } else {
        img.addEventListener('load', function () {
          img.classList.add('is-loaded');
        }, { once: true });
        img.addEventListener('error', function () {
          // Failsafe: don't strand a broken image at opacity 0
          img.classList.add('is-loaded');
        }, { once: true });
      }
    });

    // ---- Filtering ----
    filterBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var filter = btn.getAttribute('data-filter');
        if (filter === activeFilter || isAnimating) return;
        activeFilter = filter;
        isAnimating = true;

        filterBtns.forEach(function (b) { b.classList.remove('is-active'); });
        btn.classList.add('is-active');

        var toHide = [];
        var toShow = [];
        var toStay = [];

        items.forEach(function (item) {
          var cat = item.getAttribute('data-category') || '';
          var matches = (cat === filter);
          var isHidden = item.classList.contains('masonry-gallery__item--hidden');

          if (matches && isHidden) {
            toShow.push(item);
          } else if (!matches && !isHidden) {
            toHide.push(item);
          } else if (matches && !isHidden) {
            toStay.push(item);
          }
        });

        // Phase 1: fade out items that should hide
        toHide.forEach(function (item) {
          item.classList.add('masonry-gallery__item--fading-out');
        });

        // Kick off image fetches for the about-to-be-shown items *immediately*,
        // before the visual fade so the bytes are in-flight by the time they
        // start to appear. Browser ignores 'lazy' that has already been deferred,
        // so we flip to 'eager' + high fetchpriority to nudge it to start now.
        toShow.forEach(function (item) {
          item.querySelectorAll('img').forEach(function (img) {
            if (!img.complete) {
              img.loading = 'eager';
              img.fetchPriority = 'high';
            }
          });
        });

        setTimeout(function () {
          // Phase 2: actually hide them, then prep incoming items
          toHide.forEach(function (item) {
            item.classList.add('masonry-gallery__item--hidden');
            item.classList.remove('masonry-gallery__item--fading-out');
          });

          toShow.forEach(function (item) {
            item.classList.add('masonry-gallery__item--fading-in');
            item.classList.remove('masonry-gallery__item--hidden');
          });

          // Force reflow so the browser registers the fading-in state
          void grid.offsetHeight;

          // Re-evaluate the itemSelector filter (newly-shown items get
          // included, newly-hidden ones excluded) and re-position everything.
          refilter();

          // As the newly-shown images decode, masonry needs to re-position
          // in case any image's intrinsic aspect differs from its declared one.
          if (toShow.length && typeof imagesLoaded === 'function') {
            var imgLoad2 = imagesLoaded(toShow);
            imgLoad2.on('progress', relayout);
            imgLoad2.on('always', relayout);
          }

          // Phase 3: fade in new items
          requestAnimationFrame(function () {
            toShow.forEach(function (item) {
              item.classList.remove('masonry-gallery__item--fading-in');
              item.classList.add('masonry-gallery__item--visible');
            });

            setTimeout(function () {
              toShow.forEach(function (item) {
                item.classList.remove('masonry-gallery__item--visible');
              });
              isAnimating = false;
            }, FADE_IN_MS);
          });
        }, toHide.length > 0 ? FADE_OUT_MS : 0);
      });
    });

    // ---- Lightbox ----
    function getVisibleItems() {
      return Array.from(items).filter(function (item) {
        return !item.classList.contains('masonry-gallery__item--hidden');
      });
    }

    function openLightbox(index) {
      var visible = getVisibleItems();
      if (index < 0 || index >= visible.length) return;
      currentIndex = index;
      updateLightboxImage(visible, true);
      lightbox.classList.add('is-open');
      document.body.classList.add('masonry-lightbox-open');

      if (typeof trapFocus === 'function') {
        trapFocus(lightbox, lightboxClose);
      }
    }

    function closeLightbox() {
      lightbox.classList.remove('is-open');
      document.body.classList.remove('masonry-lightbox-open');

      if (typeof removeTrapFocus === 'function') {
        removeTrapFocus();
      }
    }

    var LIGHTBOX_FADE_MS = 250;
    var lightboxSwapTimer = null;

    function updateLightboxImage(visible, immediate) {
      var item = visible[currentIndex];
      var img = item.querySelector('img');
      var src = item.getAttribute('data-full-src') || img.currentSrc || img.src;
      var alt = img.getAttribute('alt') || '';

      var total = visible.length;
      lightboxCounter.textContent = (currentIndex + 1) + ' / ' + total;
      var hideNav = total <= 1;
      lightboxPrev.hidden = hideNav;
      lightboxNext.hidden = hideNav;

      // Open-from-scratch: just set src, the lightbox container fade covers it.
      if (immediate) {
        lightboxImg.classList.remove('is-swapping');
        lightboxImg.setAttribute('src', src);
        lightboxImg.setAttribute('alt', alt);
        return;
      }

      // Same image (e.g., wrap-around with single item) — skip the fade entirely.
      if (lightboxImg.getAttribute('src') === src) return;

      // 1. Fade the current image out.
      lightboxImg.classList.add('is-swapping');
      clearTimeout(lightboxSwapTimer);

      // 2. After the fade-out transition, swap src and wait for the new one to load.
      lightboxSwapTimer = setTimeout(function () {
        var preloader = new Image();
        preloader.onload = preloader.onerror = function () {
          lightboxImg.setAttribute('src', src);
          lightboxImg.setAttribute('alt', alt);
          // Next frame, drop the swap class so the new image fades in.
          requestAnimationFrame(function () {
            lightboxImg.classList.remove('is-swapping');
          });
        };
        preloader.src = src;
      }, LIGHTBOX_FADE_MS);
    }

    function navigate(dir) {
      var visible = getVisibleItems();
      currentIndex = (currentIndex + dir + visible.length) % visible.length;
      updateLightboxImage(visible);
    }

    items.forEach(function (item) {
      item.addEventListener('click', function () {
        var visible = getVisibleItems();
        var idx = visible.indexOf(item);
        if (idx !== -1) openLightbox(idx);
      });
    });

    lightboxClose.addEventListener('click', closeLightbox);

    lightbox.addEventListener('click', function (e) {
      if (e.target === lightbox || e.target.classList.contains('masonry-lightbox__img-wrap')) {
        closeLightbox();
      }
    });

    lightboxPrev.addEventListener('click', function (e) {
      e.stopPropagation();
      navigate(-1);
    });

    lightboxNext.addEventListener('click', function (e) {
      e.stopPropagation();
      navigate(1);
    });

    // Keyboard
    document.addEventListener('keydown', function (e) {
      if (!lightbox.classList.contains('is-open')) return;
      if (e.key === 'Escape') closeLightbox();
      if (e.key === 'ArrowLeft') navigate(-1);
      if (e.key === 'ArrowRight') navigate(1);
    });

    // Touch / swipe
    lightbox.addEventListener('touchstart', function (e) {
      touchStartX = e.changedTouches[0].screenX;
    }, { passive: true });

    lightbox.addEventListener('touchend', function (e) {
      touchEndX = e.changedTouches[0].screenX;
      var diff = touchStartX - touchEndX;
      if (Math.abs(diff) > 50) {
        navigate(diff > 0 ? 1 : -1);
      }
    }, { passive: true });
  }
})();
